/* HERE & ALWAYS — Accordions / Carets (global)
   - Makes any button/link with data-acc-target="#panelId" toggle aria-expanded
   - Shows/hides the target panel via [hidden]
   - Plays nicely with Shopify section loads
*/
(() => {
  function toggle(trigger, panel) {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.hidden = expanded;
  }

  function initOne(trigger) {
    if (trigger.__haAccInit) return; trigger.__haAccInit = true;

    // Find target via data-acc-target
    const sel = trigger.getAttribute('data-acc-target');
    const panel = sel ? document.querySelector(sel) : null;

    // A11y defaults
    if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    if (panel) {
      if (!trigger.hasAttribute('aria-controls')) {
        if (!panel.id) panel.id = 'ha-acc-' + Math.random().toString(36).slice(2);
        trigger.setAttribute('aria-controls', panel.id);
      }
      if (!panel.hasAttribute('hidden')) panel.hidden = true;
    }

    trigger.addEventListener('click', (e) => {
      // Let links still navigate if no target
      if (!panel) return;
      e.preventDefault();
      toggle(trigger, panel);
    });

    // Keyboard
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(trigger, panel); }
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-acc-target]').forEach(initOne);
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-init on section load/reorder
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initAll(e.target));
})();